import * as types from '@store/types'
import request from '@queries'
import axios from 'axios'
import LikeQuery from '@queries/Like'
import FavoriteQuery from '@queries/Favorite'
import CampaignQuery from '@queries/Campaign'

export const events = {
  voucher: {
    campaignButton: 'Resgatar voucher',
    eventButton: 'Baixar'
  },
  uniqueCode: {
    campaignButton: 'Solicitar Código',
    eventButton: 'Solicitar'
  },
  online: {
    campaignButton: 'Acessar',
    eventButton: ''
  },
  payment: {
    campaignButton: 'Continuar para compra',
    eventButton: ['Efetuar compra', 'Ver minhas transações', 'Voltar']
  },
  letter: {
    campaignButton: 'Solicitar carta vínculo',
    eventButton: ['Gerar carta vínculo', 'Baixar PDF', 'Enviar para e-mail']
  },
  info: {
    campaignButton: '',
    eventButton: ''
  },
  cashback: {
    campaignButton: 'Ativar e acessar',
    eventButton: ''
  },
  epay: {
    campaignButton: 'Efetuar a compra',
    eventButton: ['Efetuar compra', 'Ver minhas transações', 'Voltar']
  },
  todo: {
    campaignButton: 'Efetuar a compra',
    eventButton: ['Efetuar compra', 'ver minhas transações', 'Voltar']
  },
  pharmacy: {
    campaignButton: 'Ativar desconto',
    eventButton: ['Ativar desconto', 'Ver minhas transações', 'Voltar']
  }
}

const state = {
  campaign: {},
  event: {}
}

const getters = {
  [types.CAMPAIGN]: ({ campaign }) => campaign,

  [types.CAMPAIGN_GET_LINK]: ({ event }) => event
}

const mutations = {
  [types.CAMPAIGN]: (state, payload) => {
    state.campaign = payload
  },

  [types.CAMPAIGN_GET_LINK]: (state, payload) => {
    state.event = payload
  },

  [types.CAMPAIGN_LIKE]: (state, payload) => {
    const campaign = state.campaign

    state.campaign = {
      ...campaign,
      is_liked: payload,
      liked_count: (
        campaign.is_liked
          ? campaign.liked_count - 1
          : campaign.liked_count + 1
      )
    }
  },

  [types.CAMPAIGN_FAVORITE]: (state, payload) => {
    const campaign = state.campaign

    state.campaign = {
      ...campaign,
      is_favorited: payload
    }
  }
}

const actions = {
  [types.CAMPAIGN]: async ({ commit }, slug) => {
    commit(types.CAMPAIGN, {})

    const response = await request(CampaignQuery, { slug })

    const { campaign } = response && response.data && response.data.data || {}

    commit(types.CAMPAIGN, campaign || {})
  },

  [types.CAMPAIGN_GET_LINK]: async ({ state, dispatch, commit }, payload) => {
    dispatch(types.CAMPAIGN_EVENT_RESET)

    const { id: campaign } = state.campaign

    const url = `campaign/${campaign}/event`

    const response = await axios.post(url, payload)

    const event = response.data.data

    commit(types.CAMPAIGN_GET_LINK, event || {})

    return event
  },

  [types.CAMPAIGN_PAYMENT_PIX]: async ({ state, dispatch, commit }, payload) => {
      dispatch(types.CAMPAIGN_EVENT_RESET)
  
      const { id: campaign } = state.campaign
  
      const url = `campaign/${campaign}/event`
  
      const response = await axios.post(url, payload)
  
      const event = response.data.message
  
      commit(types.CAMPAIGN_GET_LINK, event || {})
  
      return event
    },

  [types.CAMPAIGN_TRACKING]: async ({ state, commit }, payload) => {
    const { id: campaign } = state.campaign

    const url = `campaign/${campaign}/tracking`

    await axios.post(url, payload)
  },

  [types.CAMPAIGN_PAYMENT_FLAG]: async ({ commit }, payload) => {
    const cardNumber = payload.replace(/ /g, '')

    const url = `/payment/cielo/card/${cardNumber}`

    const response = await axios.get(url)

    return { card: payload, ...response.data.data }
  },

  [types.CAMPAIGN_EVENT_RESET]: ({ commit }) => {
    commit(types.CAMPAIGN_GET_LINK, {})
  },

  [types.CAMPAIGN_LIKE]: async ({ commit, dispatch }, { slug, partner: { name: title } }) => {
    const response = await request(LikeQuery, {
      slug
    })
    const isLiked = response.data.data.like

    const type = 'LIKED_' + (isLiked ? 'ADD' : 'REMOVE')

    const text = (isLiked ? 'curtida' : 'descurtida') + ' com sucesso'

    const feedback = {
      text,
      type: 'like',
      title
    }

    commit(types.CAMPAIGN_LIKE, isLiked)
    dispatch(types.FEEDBACK, feedback)
  },

  [types.CAMPAIGN_FAVORITE]: async ({ commit, dispatch }, { slug, partner: { name: title } }) => {
    const response = await request(FavoriteQuery, {
      slug
    })
    const isFavorited = response.data.data.favorite

    const text = (isFavorited ? ' adicionada a' : ' removida d') + 'os favoritos'

    const feedback = {
      text,
      type: 'favorite',
      title
    }

    commit(types.CAMPAIGN_FAVORITE, isFavorited)
    dispatch(types.FEEDBACK, feedback)
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/campaign.js